import { render, staticRenderFns } from "./Travels.vue?vue&type=template&id=354f2e42&"
import script from "./Travels.vue?vue&type=script&lang=js&"
export * from "./Travels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports